import React from 'react';
import styled from '@emotion/styled';

const HeaderContainer = styled.div`
  padding: 48px 40px;
  text-align: center;
  margin: 16px;
`;

const Title = styled.h1`
  font-size: 44px;
  font-weight: 700;
  margin: 0 0 20px;
  color: #172B4D;
  letter-spacing: -0.5px;
  line-height: 1.2;
  
  span {
    position: relative;
    color: #0052CC;
    display: inline-block;
    
    &::after {
      content: '';
      position: absolute;
      left: -4px;
      right: -4px;
      bottom: 0px;
      height: 10px;
      background-color: rgba(0, 82, 204, 0.2);
      transform: rotate(-1deg) skewX(-12deg);
      border-radius: 3px;
      z-index: 0;
    }
    
    &::before {
      content: 'Atlassian Marketplace Listing';
      position: absolute;
      left: 0;
      right: 0;
      color: #0052CC;
      z-index: 1;
    }
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  color: #42526E;
  margin: 0;
  line-height: 1.5;
  font-weight: 400;
  max-width: 600px;
  margin: 0 auto;
`;

const PreviewHeader = () => {
  return (
    <HeaderContainer>
      <Title>
        Preview Your <span>Atlassian Marketplace Listing</span>
      </Title>
      <Subtitle>
        Get a real-time preview of your Atlassian Marketplace listing exactly as customers will see it.
      </Subtitle>
    </HeaderContainer>
  );
};

export default PreviewHeader; 